import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  currentScrollSubject: Subject<CustomEvent>;
  currentScrollSource: Observable<CustomEvent>;

  constructor() {
    this.currentScrollSubject = new Subject<CustomEvent>();
    this.currentScrollSource = this.currentScrollSubject.asObservable();
  }

}
